module.exports = __webpack_public_path__ + "img/faq4.3958e022.png";